import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-admin-blogs',
  templateUrl: './admin-blogs.component.html',
  styleUrls: ['./admin-blogs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminBlogsComponent implements OnInit {

  blogForm: FormGroup;
  public blogDetails: any;
  public blogsList: Array<any> = [];


  constructor(private formBuilder: FormBuilder, private _ref: ChangeDetectorRef, private _adminService: AdminService) {
    this.blogForm = this.formBuilder.group({
      blogTitle: ['', [Validators.required, Validators.minLength(3)]],
      blogSubTitle: ['', [Validators.required, Validators.minLength(3)]],
      blogDescription: ['', [Validators.required, Validators.minLength(3)]],
      blogCategory: ['', [Validators.required, Validators.minLength(3)]],
      blogTags: ['', [Validators.required, Validators.minLength(3)]],
      blogImagePath: [''],
      blogPostedBy: ['AM Media & Sports'],
    });
  }

  ngOnInit() {
    this.getAllBlogs();
  }

  getAllBlogs() {
    this._adminService.getAllBlogs().subscribe({
      next: (response: any) => {
        if (response && response.length > 0) this.blogsList = response;
        else this.blogsList = [];

        this.blogDetails = null;
        setTimeout(() => {
          this._ref.markForCheck();
        }, 1000);
      },
      error: (error) => {
        this.blogDetails = null;
        this.blogsList = [];
        this._ref.markForCheck();
        console.log(error);
      },
    });
  }

  getBlogById(blogId: any) {
    if (!blogId) {
      alert("Valid blog not selected for edit.");
      return;
    } else {
      this._adminService.getBlogById(blogId).subscribe({
        next: (response: any) => {
          if (response) this.blogDetails = response;
          else this.blogDetails = null;

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          this.blogDetails = null;
          this._ref.markForCheck();
          console.log(error);
        },
      });
    }
  }

  clickOnSubmit() {
    if (this.blogDetails && this.blogDetails != null) {
      this.updateAdminBlog(this.blogDetails?._id);
    } else {
      this.saveAdminBlog();
    }
  }

  saveAdminBlog() {
    if (!this.blogForm.valid) {
      alert("Blog is not have valid details.");
      this.blogForm.markAllAsTouched();
      return;
    } else {
      this._adminService.postBlog(this.blogForm.value).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('_id')) {
            alert("Blog insert successful.");
            this.blogForm.reset();
            this.getAllBlogs();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  updateAdminBlog(blogId: any) {
    if (!blogId && !this.blogForm.valid) {
      alert("Blog is not have valid details.");
      this.blogForm.markAllAsTouched();
      return;
    } else {
      this._adminService.putBlog(blogId, this.blogForm.value).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('_id')) {
            alert("Blog update successful.");
            this.blogForm.reset();
            this.getAllBlogs();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  deleteAdminBlog(blogId: any) {
    if (!blogId) {
      alert("Valid blog not selected for delete.");
      return;
    } else {
      this._adminService.deleteBlog(blogId).subscribe({
        next: (response: any) => {
          if (response) {
            alert("Blog delete successful.");
            this.blogForm.reset();
            this.getAllBlogs();
          }

          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }

  clearBlogs() {
    this.blogForm.reset();
  }
}
